import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Transportista/filtrarTransportista`, method: 'POST', body: values, token: token})
}
